<app-headnav [user]="tempInfo" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<div *ngIf="!userId" class="studio">
</div>
<div id="overlay" style="background: black url('/assets/images/loader.gif') center center no-repeat;"></div>
<div *ngIf="userId" class="studio">
	<div class="sidenav flex-container" [style.width]="sideNavWidth">
			<a href="dashboard" title="Dashboard" target=_blank>
			<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
			<span data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
			</span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

			</a>
			<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
			<a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
			</a>
			<a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
				<span aria-hidden="true" style="position: absolute; left: 86px">Templates</span>

			</a>
			<!--<a href="complete" title="Completed Reports" target=_blank>
				<i style="margin-left: 5px" class="far fa-list-alt"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
			</a>
			<a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank><i class="icon-property" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

			</a>
					
			<a title="Library and Repeat Fields" href="resources" style="border-top: 1px solid #000000" target=_blank>
			<span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>

			</a>
			<a *ngIf="userInfo.ERIS_STAFF=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank>
				<i  class="icon-eris" style="font-size: 32px;"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

				</a>-->

			<a  (click)="toggleSideBar()"> 

				<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
				<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

			</a>





			
		</div>

<div class="main">

<div class="row container-fluid p-0 m-0" style="height:100%; overflow:auto">
<div class="col-md-3 contentContainer">
	<ul class="nav nav-tabs">
    <li class="nav-item">
		<a class="nav-link active" data-toggle="tab" href="#content">Sections</a>		
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#app">Appendices</a>
    </li>
	<li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#slot" title="Repeat Field">Re-Fields<span *ngIf="curTemp">( {{ curTemp.TOTAL_TEMPLATE_SLOTS}} /{{curTemp.TOTAL_SLOTS}}  )</span></a>
    </li>
	<li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#lib" title="Libraries" (click)="checkLib()">LIB</a>
    </li>
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    <div id="content" class="container tab-pane active" style="padding:0; position:relative" >
	<ng-container>
			<div style="position:fixed; top:116px; background-color:rgb(9, 17, 33);; width:24.11%">
			<select class="expandSel">
				<option class="expandOp" value='1'>1</option>
				<option class="expandOp" value='2'>2</option>				
			</select>
			<button  type="button"  class="btn btn-black btn-list " (click)='expandToggle($event)'>Expand</button>
			</div>
		</ng-container>
		
	<div class='fixContent' >
	<div class="example-list" *ngFor="let page of frontpages;let s=index; trackBy:trackByFuntion" style="background:#000; color:white;">
		<a [id]="page.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" style="font-weight:bold" [ngClass]="{'active':listid==page.id}" (click)="getListPosition(page.id, $event);selectedRow=-1;selectedCell=null">
			<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;">
			{{page.SECTION_TITLE}}	</label>					
			<i *ngIf="page.SUB_SECTIONS&&page.SUB_SECTIONS.length>0" class="btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" style="color:#ccc" (click)="toggleChild($event)"></i>
			
		</a>
		<div class="exDiv1" style="display:none; background:#000; margin:0; padding:0;clear: right">
			<div class="example-box" *ngFor="let page1 of page.SUB_SECTIONS;let t=index; trackBy:trackByFuntion" style="background:#000;">
					<a  [id]="page1.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':page1.id==listid}" (click)="getFListPosition(page1.id, $event,s,t);selectedRow=-1;selectedCell=null">
						<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;"> . {{page1.SECTION_TITLE}}</label>
					</a>
			</div>
		</div>
	</div>
	<div class="example-list" style="background:#000; color:white;">
		<a class="dropdown-item listItem" href="javascript:void(0)" style="font-weight:bold">
			<label style="max-width: 70%; white-space: normal;color:#999;pointer-events: none;">
			Table of Contents</label>					
			
		</a>
	</div>	
	<div class="example-list" *ngFor="let group of contents;let i=index"   style="background:#444; color:white;">
		<a  [id]="group.id+'list'" class="dropdown-item listItem" [ngClass]="{'active':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1)}" href="javascript:void(0)" style="font-weight:bold" (click)="getListPosition(group.id, $event,i);selectedRow=-1;selectedCell=null">
							<label style="max-width: 75%; white-space: normal;color:white;pointer-events: none;">
								{{group.SECTION_SEQUENCE}} {{group.SECTION_TITLE}}	</label>					
								<i *ngIf="group.SUB_SECTIONS.length>0" class="btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" style="color:#ccc" (click)="toggleChild($event)"></i>
													
						</a>
		<div class="exDiv1" style="display:none; background:#000; margin:0; padding:0;clear: right">
	<div class="example-list"   *ngFor="let items of group.SUB_SECTIONS;let j=index" style="background:#444; color:white">
		<a [id]="items.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':(curIndex[0]==i)&&curIndex[1]==j&&!(curIndex[2]>-1)}" (click)="getListPosition(items.id, $event,i,j);selectedRow=-1;selectedCell=null">
									<label style="max-width: 75%; white-space: normal;color:white;pointer-events: none;"> . {{items.SECTION_SEQUENCE}} {{items.SECTION_TITLE}}</label>
									<i *ngIf="items.SUB_SECTIONS?.length>0" class=" btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" (click)="toggleChild($event)" style="color:#ccc"></i>
									
									</a>
		<div class="example-list exDiv2" id={{items.SECTION_SEQUENCE}}  
    		style="display:none; background:#000000; clear: right">
			<div class="example-box" 
				*ngFor="let item of items.SUB_SECTIONS;let k=index" 
				style="background:#444;">
					<a  [id]="item.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}" (click)="getListPosition(item.id, $event,i,j,k);selectedRow=-1;selectedCell=null">
						<label style="max-width: 75%; white-space: normal;color:white;pointer-events: none;"> . . {{item.SECTION_SEQUENCE}} {{item.SECTION_TITLE}}</label>
						
					</a>
			</div>
		</div>
	</div>
</div>
	</div>
</div>
</div>
<div id="app" class="container tab-pane fade" style="padding:0">
	<div *ngIf="appendices" class="example-list dropdown-item listItem" style="font-weight:bold; background:#000;">
		<label style="max-width:70%;  white-space: normal;color:white;pointer-events: none;">{{appendices?.SECTION_TITLE}}</label>
		
	</div>
	<div *ngIf="appendices"  class="example-list" style="background:#000;">
			<div class="example-list" *ngFor="let item of appendices.SUB_SECTIONS;let i=index" style="background:#000;">
					<a class="dropdown-item listItem" href="javascript:void(0)" (click)="selectedRow=-1;selectedCell=null">. {{item.SECTION_SEQUENCE}}
						<label style="max-width:65%; white-space: normal; color:white;pointer-events: none;">{{item.SECTION_TITLE}}</label>
										
					</a>
					<div class="example-list"  style="background:#000;clear: right">
						<div  class="example-box" *ngFor="let rf of item.app;let k=index" style="background:#000;">
							<a class="dropdown-item listItem" href="javascript:void(0)">
								<div style="max-width: 100%; white-space: normal; padding-left:20px; height:24px; padding-top:4px"> 
								<a  *ngIf='rf?.url?.length>0' [href]="rf?.url" target=_blank  [ngStyle]="{'color': rf?.url?.length>0&&(rf.type=='PDF'||rf.type=='pdf')? 'rgb(195,212,47)':'white'}" >{{rf.name}}{{rf.text}}</a>
								</div>
								
							</a>
	
						</div>
					</div>
			</div>
		</div>
</div>
<div id="slot" class="container tab-pane fade" style="padding:0">
	<!--<div *ngIf="slotGroup=='S'">
	<label class="group-title">Selection Slots</label>
		<p-table #dt1 [value]="selSlots" [paginator]="false" [globalFilterFields]="['KEY','CONTENT']"  (onFilter)="onFilter($event, dt1)">
			<ng-template pTemplate="body" let-rowData>
					<tr *ngIf="rowData.KEY">
						<td style="background-color:rgb(28, 36, 51)">
							<div class="card"> 						
								<div class="row"  style="width:100%">
									<label style="width:85%; margin-top:8px;margin-left:16px;color:rgb(195,212,47)">{{rowData.KEY}}<span style="color:#04B486; margin:0 2px">({{rowData.TYPE}})</span></label>
									<a *ngIf="rowData.CONTENT.length>0" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op11.toggle($event);"><i class="fas fa-eye"></i></a>					
									<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('choice', rowData)"><i *ngIf="addLib" class="fas fa-arrow-right"></i></a>
									</div>
								<span>{{rowData.SHORT_CONTENT}}</span>
									<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{rowData.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{rowData.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{rowData.TYPE}}</span><br>
														<div *ngIf="rowData.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="rowData.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Seleciton )</span><span *ngIf="rowData.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Seleciton ) </span><br>
														
															<ng-container *ngFor="let item of tableContent; trackBy:trackByFuntion">
																<span  style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>														
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
															
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	
	</div>-->
	<div *ngIf="slotGroup!='S'" class="fixTable">
	<p-table #tb [columns]="cols2" [value]="groupSlots" dataKey="CATEGORY" sortMode="single" [expandedRowKeys]="expandedRows"><!-- (onPage)="onPage($event)" (onRowExpand)="onRowExpand()" (onRowCollapse)="onRowCollapse()"-->
    <ng-template pTemplate="caption">
	<div style="float: left; display:inline-block">
		<a style="cursor: pointer;font-size: 16px; color:rgb(195,212,47);" (click)="expandAll()">
			<i *ngIf="!isExpanded" class="fas fa-angle-double-right"></i>
			<i *ngIf="isExpanded" class="fas fa-angle-double-down"></i>
		</a>
		<i class="pi pi-refresh" style="margin:4px 4px 0 20px" pTooltip="Reload Repeat Fields" (click)='refreshSlots()'></i>

	</div>
        <div style="float: right; display:inline-block">        
            
            <input type="text" pInputText size="10" placeholder="Filter" (change)="filterSlot($event)" style="width:auto">
			<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterSlot($event)'></i>
			<!--<a style="cursor: pointer; font-size: 16px;" (click)="op2.toggle($event);" title="Add Repeat Field">
                                                <i class="pi pi-plus" style="margin: 5px;"></i>
                                            </a>
                        
                                            <p-overlayPanel #op2 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '500px'}" (onShow)="resetNewSlot()">
                                                <ng-template pTemplate>
                                                    <div style="width: 440px; margin: 10px; padding-right:0; color:#C2D63F;"> 
													<h6>Add Repeat Field</h6>
													<hr>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0 ">Identifier: </label>
														<input class="col-md-8 ml-0" type="text" [(ngModel)]='newSlotLabel'/>
														<span style="font-weight:bold" [ngStyle]="{'color':newSlotLabel.trim()=== '' ? 'red' : 'white' }">*</span>
													</div>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0">Category : </label>
														<input type='text' class="col-md-7" [(ngModel)]='newSlotCat'>
														<select class="col-md-1  ml-0" [(ngModel)]='newSlotCat'  (mousedown)="getSlotPara()">
															<ng-container *ngFor="let cat of slotCategories; trackBy:trackByFuntion">
																<option [value]="cat.CATEGORY">{{cat.CATEGORY}}</option>				
															</ng-container>
														</select>
														<span style="font-weight:bold" [ngStyle]="{'color':newSlotCat.trim()=== '' ? 'red' : 'white' }">*</span>
													</div>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0">Type : </label>
														<select [ngClass]="newSlotType=='Selection'? 'col-md-4':'col-md-8'" [(ngModel)]='newSlotType'>
															<ng-container *ngFor="let type of slotTypes">
																<option [value]="type.SLOT_TYPE"><label class="mr-2">{{type.SLOT_TYPE}}</label></option>				
															</ng-container>
														</select>
														<select *ngIf="newSlotType=='Selection'" class="col-md-4" [(ngModel)]='newSlotMultiple' style="padding-left:0">
															<option value="N">Single Choice</option>
															<option value="Y">Multiple Choice</option>																
														</select>
														<span style="font-weight:bold" [ngStyle]="{'color':newSlotType=== '' ? 'red' : 'white' }">*</span>
													</div>
													<div class="row p-1" style="font-size:.9em; max-height:300px">
														<label class="col-md-3  ml-0">Content: 	</label>
														<textarea *ngIf="newSlotType!='Selection'&&newSlotType!='File'" class="col-md-8  ml-0" rows="10" [(ngModel)]='newSlotContent'></textarea>
														<input *ngIf="newSlotType=='Selection'" class="col-md-7  mt-1" [(ngModel)]='newSlotOp'>
														<a href="javascript:void(0)" *ngIf="newSlotType=='Selection'" class="col-md-1 ml-0 mt-1 mr-0 slotBtn" (click)="addOpItem($event)"><i class="fas fa-plus"></i></a>
												
														<ng-container *ngIf="newSlotType=='File'">
															<button  class="btn btn-outline-light btn-op ml-0 mr-2" (click)="upload('slot')">Upload File</button>
															<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>
															<br>
															<a [href]="newSlotFile.url"  style="margin-left:25%; width:70%; word-break: break-all;" target=_black>{{newSlotFile.name}}</a>															
																												
														</ng-container>
														<label class="col-md-3  ml-0"></label>
														<button  *ngIf="newSlotType!='Selection'&&newSlotType!='File'" class="btn btn-outline-light float-btn m-1  slotBtn" data-target='#libraryModal' data-toggle="modal" (click)="checkLib();libToSlot=true;filteredData=null">Libraries</button>		
														<ng-container *ngIf="newSlotType=='Selection'&&newSlotOps.length>0">
															<div  class="selInput col-md-12" style="max-height:300px; overflow:auto; font-size:.9em; border:1px solid gray; padding:0; margin:4px; width:90%">
																<ng-container *ngFor="let item of newSlotOps; let i=index; trackBy:trackByFuntion">
																	<div class="row" style="width:100%; margin:4px 0; padding:0"><label class="col-md-10 ml-1 mb-0">. {{item}}</label>
																	<span class="small"><i class="fas fa-arrow-up float-right"  title="Move Up" (click)="selUp(i)"></i></span>
																	<span class="small"><i class="fas fa-arrow-down float-right" title="Move Down" (click)="selDown(i)"></i></span>
																	<span class="small"><i class="far fa-trash-alt float-right"  title="Remove" (click)="selRemove(i)"></i></span>
																	</div>
																</ng-container>
															</div>
																</ng-container>
									
														</div>
														<label *ngIf="missingSlot==true" style="color: red; width:100%; font-size:.8em">&nbsp;{{missingSlotMessage}}</label>
														
														<button type="button"  class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createSlot($event, op2);">Create</button>
														<button type="button"  class="btn btn-outline-light btn-sm float-md-right m-4"  (click)="createSlot($event);">Save and Create Repeat Field</button>
			                                           
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>-->
		</div>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr style="font-size:12px"><!-- [pSelectableRow]="rowData" -->
            <td style="background-color:rgb(28, 36, 51)">
                <a href="#" [pRowToggler]="rowData">
                    <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                </a>
            </td>
            <td *ngFor="let col of columns; trackBy:trackByFuntion"  style="padding:6px;background-color:rgb(28, 36, 51)"  [ngStyle]="{'width': col.width}">
				<ng-container *ngIf="col.field=='CATEGORY'">
					{{rowData[col.field]}}
					<span *ngIf="rowData.TOTAL_SLOTS">( {{ rowData.TOTAL_TEMPLATE_SLOTS}} /{{rowData.TOTAL_SLOTS}}  )</span>
					<!--<a href="javascript:void(0)" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" title="Check All"  style="float:right; font-size:.9em;color:rgb(195,212,47)" [ngStyle]="{'color':rowData.RW_SLOTS.length>0?'white':'rgb(195,212,47)'}" (click)="slotChkToggle(rowData)">
						Check All
					</a>-->
				</ng-container>               
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="cols3">
        <tr>
            
				<td [attr.colspan]="cols2.length + 1" style="padding:0 20px;background-color:rgb(28, 36, 51)">
				<ng-container *ngFor="let r of rowData.RW_TEMPLATE_SLOTS">
					<div class="card" style="margin:10px 0; "> 
						<div class="row"  style="width:100%; padding:0 0 0 16px;">
						<label style="width:85%; margin-top:8px;color:rgb(195,212,47)">{{r.KEY}}<span style="color:#04B486; margin:0 2px">({{r.TYPE}})</span>
							<i *ngIf="r.SYSTEM_IND=='Y'" class="fas fa-globe"></i>
							<i *ngIf="r.SYSTEM_IND=='N'" class="fas fa-cog"></i></label>
							<input *ngIf="curTemp?.TEMPLATE_ID" disabled style="width:5%; margin-top:8px" type="checkbox" [checked]="r.TEMPLATE_IND=='Y'" (change)="addSlotToTemp($event, r, rowData.CATEGORY)"/>
							<a *ngIf="r.CONTENT.length>0&&r.TYPE!='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op10.toggle($event);"><i class="fas fa-eye"></i></a>					
							<a *ngIf="r.SELECTION_CHOICES.length>0&&r.TYPE=='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op10.toggle($event);"><i class="far fa-list-alt"></i></a>
							<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px" class="btn btn-link btn-sm pt-0 pb-0 pl-1 pr-1" title="Delete Item" (click)="deleteSlot(r, rowData)"><i class="far fa-trash-alt"></i></a>-->					
							<!--<a *ngIf="addLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'"  href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('slot', r)"><i class="fas fa-arrow-right"></i></a>	
							<a *ngIf="newLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', r)"><i class="fas fa-arrow-right"></i></a>-->
							</div>
							<span style="color:white">{{r.SHORT_CONTENT}}</span>
							<p-overlayPanel #op10 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(r)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{r.KEY}}</strong><br>
													<!--<hr>
														<strong>Content :</strong>
														<span *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">{{r.CONTENT}}</span>-->
														<strong>Category : </strong> 
													<span style="color:white">{{r.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{r.TYPE}}</span><br>
														<strong   *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">Content : </strong> 
														<span  *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')&&(r.TYPE!='File')" style="color:white">{{r.CONTENT}}</span><br>
														<a *ngIf="r.TYPE=='File'" [href]="r.CONTENT" target=_blank style="color:#C2D63F; width:100%; word-break:break-all">{{r.FILE_NAME}}</a>	
														<div *ngIf="r.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="r.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Seleciton )</span><span *ngIf="r.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Seleciton ) </span><br>
														
															<ng-container *ngFor="let item of tableContent; trackBy:trackByFuntion">
																<span style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>
														<div *ngIf="r.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="width:90%; border: 1px solid black;  border-collapse: collapse; color:white">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index; trackBy:trackByFuntion">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
										
										
					</div>
				</ng-container>
				<ng-container *ngFor="let r of rowData.RW_SLOTS">
					<div class="card" style="margin:10px 0; "> 
						<div class="row"  style="width:100%; padding:0 0 0 16px;">
							<label style="width:85%; margin-top:8px;color:rgb(195,212,47)">{{r.KEY}}<span style="color:#04B486; margin:0 2px">({{r.TYPE}})</span>
							<i *ngIf="r.SYSTEM_IND=='Y'" class="fas fa-globe"></i>
							<i *ngIf="r.SYSTEM_IND=='N'" class="fas fa-cog"></i></label>
							<input *ngIf="curTemp?.TEMPLATE_ID" disabled style="width:5%; margin-top:8px" type="checkbox" [checked]="r.TEMPLATE_IND=='Y'" (change)="addSlotToTemp($event, r, rowData.CATEGORY)"/>
							<a *ngIf="r.CONTENT.length>0&&r.TYPE!='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op11.toggle($event);"><i class="fas fa-eye"></i></a>
							<a *ngIf="r.SELECTION_CHOICES.length>0&&r.TYPE=='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op11.toggle($event);"><i class="far fa-list-alt"></i></a>
							<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px" class="btn btn-link btn-sm pt-0 pb-0 pl-1 pr-1" title="Delete Item" (click)="deleteSlot(r, rowData)"><i class="far fa-trash-alt"></i></a>-->					
							<!--<a *ngIf="addLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('slot', r, rowData.CATEGORY)"><i class="fas fa-arrow-right"></i></a>
							<a *ngIf="newLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', r, rowData.CATEGORY)"><i class="fas fa-arrow-right"></i></a>-->		
							</div>
							<span style="color:white">{{r.SHORT_CONTENT}}</span>
						<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(r)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{r.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{r.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{r.TYPE}}</span><br>
														<strong   *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">Content : </strong> 
														<span  *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')&&(r.TYPE!='File')" style="color:white">{{r.CONTENT}}</span><br>
														<a *ngIf="r.TYPE=='File'" [href]="r.CONTENT" target=_blank style="color:#C2D63F; width:100%; word-break:break-all">{{r.FILE_NAME}}</a>	
														<!--<strong>Content :</strong>
														<span *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">{{r.CONTENT}}</span>-->
														<div *ngIf="r.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="r.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Seleciton )</span><span *ngIf="r.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Seleciton ) </span><br>
															<ng-container *ngFor="let item of tableContent; trackBy:trackByFuntion">
																<span style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>
														<div *ngIf="r.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="width:90%; border: 1px solid black;  border-collapse: collapse; color:white">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index; trackBy:trackByFuntion">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
											
										
					</div>
				</ng-container>
				
            </td>
           
        </tr>
    </ng-template>
</p-table>
	</div>
</div>
<div id="lib" class="container tab-pane fade" style="padding:0; color:white">
	<div class="fixTable">
	<p-table #dt2 [value]="libraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','LABELS']"  (onFilter)="onFilter($event, dt2)">
				<ng-template pTemplate="caption">
					
						<div style="float: left; display:inline-block">   
							<p-dropdown [options]="libLabels"  placeholder="Identifier" [style]="{'width':'160px','minWidth':'50px', 'minHeight':'26px', 'height':'30px'}" (onChange)="dt2.filter($event.value, 'LABELS', 'contains')"  [showClear]="true"></p-dropdown>
							
						</div>
						<div style="float: right; display:inline-block">
							<i class="pi pi-refresh" style="margin-right: 20px " pTooltip="Reload Libraries" (click)='refreshLibs()'></i>
							<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47)"></span>								
							<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="10" placeholder="Filter" (input)="dt2.filterGlobal($event.target.value, 'contains')" style="width:auto">
							
						</div>
	
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr>
						<td style="background-color:rgb(28, 36, 51)">
							<div class="card" [ngClass]="{'active':addedLibs.indexOf(rowData.LIBRARY_ID)>-1}"> 						
								<div class="row">
								<p style="width:75%; margin-left:16px;color:rgb(195,212,47);">{{rowData.ITEM_TITLE}}</p>
								<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op1.toggle($event);"><i class="fas fa-eye"></i></a>					
								<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right"  title="Delete Library" (click)="deleteLib(rowData)"><i class="fas fa-trash"></i></a>	
								<a *ngIf="addLib"  href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="selectedCell=null; addRepeat('lib', rowData)"><i class="fas fa-arrow-right"></i></a>-->	
								</div>
								<span>{{rowData.SHORT_CONTENT}}</span>
								
								<p-overlayPanel #op1 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '600px'}" (onShow)="getSftContent(rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<h6>{{rowData.ITEM_TITLE}}</h6>
													<ng-container *ngFor="let label of rowData.LABELS.split(';'); trackBy:trackByFuntion">
														<label class="tag">{{label}}</label>
													</ng-container>
													<div>
														<strong>Instruction: </strong>
														<span style="color:white">{{rowData.INSTRUCTIONS}}</span>
													</div>
													<div>
														<strong>Content: </strong>
														<span *ngIf="rowData.CONTENT_HTML.length==0" style="color:white">{{rowData.CONTENT}}</span>
														<div *ngIf="rowData.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="rowData.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
													</div>
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
							</div>
										
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	</div>
</div>

</div>
	
	
</div>
<div class="col-md-7 editContainer">

<div class="tool sticky-top row p-0">
<button class="btn btn-black btn-sm mr-1" title="Portrait" [ngStyle]="{'border':selectpage.type==='portrait'? '1px solid yellow':'none'}" (click)="selectPage('portrait')"><i class="fas fa-arrows-alt-v"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Landscape" [ngStyle]="{'border':selectpage.type==='landscape'? '1px solid yellow':'none'}" (click)="selectPage('landscape')"><i class="fas fa-arrows-alt-h"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Margin" data-target='#marginModal' data-toggle="modal"><i class="fas fa-arrows-alt"></i>
</button>
</div>

<div class="pageContainer">
<div *ngIf="tempInfo"  class="example-list"  #viewer [style.padding-top.px]="pageMargin.top" [style.padding-bottom.px]="pageMargin.bottom" [style.padding-left.px]="pageMargin.left" [style.padding-right.px]="pageMargin.right" [style.width.px]="selectpage.size.width"  [style.min-height.px]="selectpage.size.height"><!-- [style.height.px]="selectpage.size.height"-->
	<div *ngFor="let page of frontpages; let s=index; trackBy:trackByFuntion" [ngClass]="{'hideSec':page.HIDE}"  style="position:relative">
		
		<button  *ngIf="page.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
		<label [id]="page.id+'content'" style="font-weight:bold"  [ngClass]="{'blue':listid==page.id}" (click)="addLib=false; getFPosition(page.id, $event,s)"><span style="color:white">.</span>{{page.SECTION_TITLE}}</label>
		
				<div *ngIf='page.text&&page.text.length>0' style="width:100%; padding:10px; margin:0" [innerHTML]="page.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
				</div>
			
			<div *ngFor="let page1 of page.SUB_SECTIONS; let t=index; trackBy:trackByFuntion" style="position:relative">
			<label [id]="page1.id+'content'" style="font-weight:bold"  [ngClass]="{'blue':listid==page1.id, 'hideSec':(page1.TYPE=='TABLE'&&page1.OTNAME)||(page1.TYPE=='PHOTOS'&&page1.OPNAME)||(page1.TYPE=='PARA'&&page1.OSNAME)}" (click)="addLib=false; getFPosition(page1.id, $event,s, t)"><span style="color:white">.</span>{{page1.SECTION_TITLE}}</label>
			
				<div *ngIf='page1.text&&page1.text.length>0' style="width:100%; padding:10px; margin:0" [innerHTML]="page1.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
				</div>
			
			
	<table *ngIf="(page1.TYPE=='TABLE'&&page1.data&&(!page1.data?.erisName))" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
		<thead>
			<tr [ngStyle]="{'background':page1.OHEADER?'#C4C4C4':'none'}">
				<ng-container *ngFor="let h of page1.data?.cols; let o=index; trackBy:trackByFuntion">
					<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
						<span style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
					</th>
				</ng-container>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
				<tr *ngIf="r.items?.length>1">
					<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
						<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
							<span *ngIf="k.DATA" [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|safeHtml'></span>
						</td>														
					</ng-container>
				</tr>
				<tr *ngIf="r.items?.length==1">
					<td [attr.colspan]='page1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
						<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
					</td>
				</tr>
			</ng-container>
		</tbody>
	</table>
	
	</div>		
	</div>
	<div *ngFor="let doc of contents; let i=index; trackBy:trackByFuntion" [ngClass]="{'hideSec':doc.HIDE}" style="position:relative">
		<button  *ngIf="doc.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
		<!--<label class='seq' [ngClass]="{'blue':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1)}" (click)="getPosition(doc.id, $event,i)">{{doc.SECTION_SEQUENCE}}</label>-->
		<label [id]="doc.id+'content'"   style="font-weight:bold" [ngClass]="{'blue':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1), 'hideSec':doc?.OSNAME||doc?.OPNAME}" (click)="getPosition(doc.id, $event,i)">{{doc.SECTION_SEQUENCE}} {{doc.SECTION_TITLE}}</label>
		
			<div *ngIf='(allEditor.indexOf(i.toString()+"--")>-1||(doc.text&&doc.text.length>0))&&!doc?.intro' style="width:100%; padding:10px; margin:0" [innerHTML]="doc.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
			</div>
		
		<div class="intro"  (click)="getPosition(doc.id, $event,i)" *ngIf='(allEditor.indexOf(doc.id)>-1||(doc.text&&doc.text.length>0))&&doc?.intro'>
			<button class="intro-btn btn btn-sm">Instruction Only</button>
			<div [innerHTML]='doc.text' style="width:100%; margin:0"></div>
		</div>
		
		<div *ngFor="let doc1 of doc.SUB_SECTIONS; let j=index; trackBy:trackByFuntion"  [ngClass]="{'hideSec':doc1.HIDE}" style="position:relative">
			<button  *ngIf="doc1.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
			<!--<label class='seq' style="margin-left:10px" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&!(curIndex[2]>-1)}" (click)="getPosition(doc1.id, $event,i,j)">. {{doc1.SECTION_SEQUENCE}} </label>-->
			<label  [id]="doc1.id+'content'" (click)="getPosition(doc1.id, $event,i,j)" style="font-weight:bold" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&!(curIndex[2]>-1),'hideSec':doc1?.OTNAME||doc1?.OSNAME||doc1?.OPNAME}">. {{doc1.SECTION_SEQUENCE}}  {{doc1.SECTION_TITLE}}</label>
			
			<br>
			
			<div class="puretext" (click)="getPosition(doc1.id, $event,i,j)">
			<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-")>-1&&otherTypes.indexOf(doc1.TYPE)==-1||(doc1.text&&doc1.text.length>0))&&!doc1?.intro' style="width:100%; padding:10px; margin:0" [innerHtml]="doc1.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
			</div>
			
			</div>
			
			<div class="intro"   (click)="getPosition(doc1.id, $event,i,j)" *ngIf='(allEditor.indexOf(doc1.id)>-1&&otherTypes.indexOf(doc1.TYPE)==-1||(doc1.text&&doc1.text.length>0))&&doc1?.intro'>
				<button class="intro-btn btn btn-sm">Instruction Only</button>
				<div [innerHTML]='doc1.text' style="width:100%; margin:0"></div>
			</div>
			
			<table *ngIf="((doc1.TYPE=='TABLE'&&doc1.data?.erisName)||doc1.TYPE=='COSTTABLE'||doc1.TYPE=='PCATABLE')&&doc1.data" style="width:100%; font-size:10px; font-family:Arial, sans-serif;">
  <tr style="background-color:#eeeeee;">
  <th *ngIf="doc1.TYPE=='TABLE'&&(!doc1.data.erisName)" style="width:40px"></th>
    <ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
	<th  *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}">
	<label>{{h.NAME}}</label>
	</th>
	</ng-container>
  </tr>
  <ng-container *ngIf="doc1.data?.src==0||doc1.data?.src==2||(!doc1.data?.src);">
  <ng-container *ngFor="let r of doc1.data?.rows; let h=index; trackBy:trackByFuntion">
  <tr *ngIf="r.length>1">
	<td *ngIf="doc1.TYPE=='TABLE'" style="font-size:.8em; background-color:#eeeeee; width:40px">
	</td>
    <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
		<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" [ngClass]="{'active':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j}">
			<label>{{k.DATA}}</label>			
		</td>		
	</ng-container>
  </tr>
  <tr *ngIf="r.length==1&&doc1.data">
  <td style="font-size:.8em; background-color:#eeeeee; width:40px">
	</td>
		<td colSpan='{{doc1.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold">
			<label>{{r[0].DATA}}</label>
		</td>
  </tr>
  </ng-container>
  </ng-container>
</table>
<!--<div *ngIf="doc1.id==curId" [ngClass]="{'hideSec':doc1.OTABLE}">
<button  *ngIf="doc1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
<div *ngIf="doc1.data&&(!doc1.data?.erisName)&&doc1.TYPE=='TABLE'">        
  <p-table [value]="doc1.data?.rows" selectionMode="multiple" [(selection)]="selectedrows" [metaKeySelection]="true" [columns]="doc1.data?.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, doc1.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, doc1)">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="background:white;width:2rem;"></th>
            <th *ngFor="let col of columns; let s=index" style="background:white;vertical-align:middle; padding:1px" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn  pResizableColumn class="cellItem">
                <span *ngIf="!col.htmltext" class="headerCell" [innerHTML]="col.NAME"></span>
				<span *ngIf="col.htmltext" class="headerCell" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				<a (click)="selectCol(doc1, s, col);getPosition(doc1.id,$event,i,j)" class="float-right" style="cursor:pointer; margin-right:8px" title="Edit"><i class="far fa-edit" style="color:#ccc"></i></a>
			</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index" [pSelectableRow]="rowData" [pSelectableRowIndex]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, doc1, index);selectedCell=null;getPosition(doc1.id,$event,i,j)" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null;getPosition(doc1.id,$event,i,j)"></span>
            </td>			
        
			<ng-container *ngIf="rowData.items[0].colspan">
			<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(doc1, index, columns[0], rowData.items[0]);getPosition(doc1.id,$event,i,j)" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
				<span class="innerCell" *ngIf="rowData.items[0].DATA" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				<a (click)="selectCell(doc1, index, columns[0], rowData.items[0]);getPosition(doc1.id,$event,i,j)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="far fa-edit"></i></a>
				
			</td>
			</ng-container>	
			<ng-container *ngIf="!rowData.items[0].colspan">
			<td *ngFor="let col of columns; let u=index" [ngStyle]="{'text-align':col.colAlign, 'background':rowData.items[u].bkcolor? rowData.items[u].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(doc1, index, col, rowData.items[u]);getPosition(doc1.id,$event,i,j)" [ngClass]="{'rowHide':rowData.hide}">
				<span class="innerCell" *ngIf="rowData.items[u].DATA" [innerHTML]="rowData.items[u].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				<a (click)="selectCell(doc1, index, col, rowData.items[u]);getPosition(doc1.id,$event,i,j)" class="float-right"  [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="far fa-edit"></i></a>
				
			</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table> 
</div>
</div>-->	
<div [ngClass]="{'hideSec':doc1.OTABLE}" class='puretext' (click)="getPosition(doc1.id,$event,i,j);resetProp(doc1)">
	<button  *ngIf="doc1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
	<table *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&(!doc1.data?.erisName)" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
				<thead>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<span *ngIf="!h.htmltext" style="font-weight:bold" [innerHTML]="h.NAME"></span>
							<span *ngIf="h.htmltext" style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="k.DATA" [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|safeHtml'></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
							<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
			<table *ngIf="doc1.TYPE=='PITABLE'&&doc1.data" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
				<thead>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<span style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}">{{h.NAME}}</span>
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.length>1">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="!k.secHtml">{{k.data}}</span>
								<span *ngIf="k.secHtml" [innerHTML]="k.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>								
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.colspan">
						<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
							{{k.data}}
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
</div>	
<div *ngFor="let doc2 of doc1.SUB_SECTIONS; let k=index; trackBy:trackByFuntion"  [ngClass]="{'hideSec':doc2.HIDE}" style="position:relative">
				<button  *ngIf="doc2.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
				<!--<label class='seq' style="margin-left:20px" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}" (click)="getPosition(doc2.id, $event,i,j,k)">. . {{doc2.SECTION_SEQUENCE}}</label>-->
				<label  [id]="doc2.id+'content'"  style="font-weight:bold" (click)="getPosition(doc2.id, $event,i,j,k)" style="font-weight:bold" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k, 'hideSec':doc2?.OTNAME||doc2?.OSNAME||doc2?.OPNAME}">. . {{doc2.SECTION_SEQUENCE}} {{doc2.SECTION_TITLE}}</label>
				
				<br>
				
				<div class="puretext" (click)="getPosition(doc2.id,$event,i, j, k)">
				<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-"+k.toString())>-1||(doc2.text&&doc2.text.length>0))&&!doc2?.intro'  style="padding:10px; margin:0" [innerHtml]="doc2.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
				</div>
				</div>
				<div class="intro"   (click)="getPosition(doc2.id,$event,i, j, k)" *ngIf='(allEditor.indexOf(doc2.id)>-1||(doc2.text&&doc2.text.length>0))&&doc2?.intro'>
					<button class="intro-btn btn btn-sm">Instruction Only</button>
					<div [innerHTML]='doc2.text' style="width:100%; margin:0"></div>
				</div>
				<table *ngIf="((doc2.TYPE=='TABLE'&&doc2.data?.erisName)||doc2.TYPE=='COSTTABLE'||doc2.TYPE=='PCATABLE')&&doc2.data" style="width:100%; font-size:10px; font-family:Arial, sans-serif;">
  <tr style="background-color:#eeeeee;">
  <th  *ngIf="doc2.TYPE=='TABLE'&&(!doc2.data.SLOT_ID||!(doc2.data.SLOT_ID>-1))" style="width:40px"></th>
    <ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
	<th  *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}">
		<label>{{h.NAME}}</label>
	</th>
	</ng-container>
  </tr>
  <ng-container *ngIf="doc2.data?.src==0||(!doc2.data?.src)">
  <ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
  <tr  *ngIf="r.length>1">
	<td  *ngIf="doc2.TYPE=='TABLE'" style="font-size:.8em; background-color:#eeeeee; width:40px">
	</td>
    <ng-container *ngFor="let m of r; let q=index; trackBy:trackByFuntion">
		<td *ngIf="!m.hide||m.hide=='N'" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" [ngClass]="{'active':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}">
			<label>{{m.DATA}}</label>			
		</td>		
	</ng-container>
  </tr>
  <tr *ngIf="r.length==1&&doc2.data">
	<td style="font-size:.8em; background-color:#eeeeee; width:40px">
	</td>
		<td colSpan='{{doc2.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}"  style="font-weight:bold">
			{{r[0].DATA}}
		</td>
  </tr>
  </ng-container>
  </ng-container>
</table>
<!--<div *ngIf="doc2.id==curId" [ngClass]="{'hideSec':doc2.OTABLE}">
<button  *ngIf="doc2.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
<div *ngIf="doc2.data&&(!doc2.data?.erisName)&&doc2.TYPE=='TABLE'">        
  <p-table [value]="doc2.data.rows" [columns]="doc2.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, doc2.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, doc2)">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="background:white;width:2rem;"></th>
            <th *ngFor="let col of columns; let t=index" style="background:white;vertical-align:middle; padding:1px" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn  pResizableColumn class="cellItem">
                <span *ngIf="!col.htmltext" class="headerCell" [innerHTML]="col.NAME"></span>
				<span *ngIf="col.htmltext" class="headerCell" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				<a (click)="selectCol(doc2, t, col);getPosition(doc2.id,$event,i,j,k)" class="float-right" style="cursor:pointer; margin-right:8px" title="Edit"><i class="far fa-edit" style="color:#ccc"></i></a>
				
				 </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, doc2, index);selectedCell=null;getPosition(doc2.id,$event,i,j,k)" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null;getPosition(doc2.id,$event,i,j,k)"></span>
            </td>			
        	<ng-container *ngIf="rowData.items&&rowData.items.length>0&&rowData.items[0].colspan">
			<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(doc2, index, columns[0], rowData.items[0]);getPosition(doc2.id,$event,i,j,k)" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
				<span class="innerCell" *ngIf="rowData.items[0].DATA" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				<a (click)="selectCell(doc2, index, columns[0], rowData.items[0]);getPosition(doc2.id,$event,i,j)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="far fa-edit"></i></a>
				
			</td>
			</ng-container>	
			<ng-container *ngIf="rowData.items&&rowData.items.length>0&&(!rowData.items[0].colspan)">
			<td *ngFor="let col of columns; let z=index" [ngStyle]="{'text-align':col.colAlign, 'background':rowData.items[z].bkcolor? rowData.items[z].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(doc2, index, col, rowData.items[z]);getPosition(doc2.id,$event,i,j,k)" [ngClass]="{'rowHide':rowData.hide}">
				<span class="innerCell" *ngIf="rowData.items[z].DATA" [innerHTML]="rowData.items[z].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				<a (click)="selectCell(doc2, index, col, rowData.items[z]);getPosition(doc2.id,$event,i,j)" class="float-right"  [ngStyle]="{'color':rowData.items[z].libs&&rowData.items[z].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="far fa-edit"></i></a>
				
			</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table> 
</div>
</div>-->
<div [ngClass]="{'hideSec':doc2.OTABLE}" class='puretext' (click)="getPosition(doc2.id,$event,i, j,k);resetProp(doc2)">
<button  *ngIf="doc2.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
<table *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&(!doc2.data?.erisName)" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;width:100%">
				<thead>
				<tr>
					<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<span *ngIf="!h.htmltext" style="font-weight:bold" [innerHTML]="h.NAME"></span>
							<span *ngIf="h.htmltext" style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="k.DATA" [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|safeHtml'></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc2.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
							<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
</div>
</div>
		</div>		
	</div>
</div>

</div>
</div>
<div class="col-md-2 toolContainer">
<!-- Nav tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#home">Tools</a>
    </li>
    <!--<li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#menu1" (click)="getHistory()">Saved</a>
    </li> -->   
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    <div id="home" class="container tab-pane active" >
	<div class="toolGroup">	
	<div class="row mt-2 mb-0 p-0" style="width:100%">
		<!--<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" (click)='preview()'>Generate PDF</button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" (click)="preview('apponly')">Appendix Only</button>
		<button class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="preview('app')">Generate PDF with Appendix</button>
		<hr class="line1">		
		<button class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)='opPrjFile()'>Project Documents</button>
		<hr class="line1">
		--><label class="savedLabel col-md-4">Cover Page: </label>
		<span class="col-md-7">
		<a *ngIf="selectedCover?.COVERPAGE_ID" class="savedTitle"  href="javascript:void(0)" (click)="openCoverPage(selectedCover.COVERPAGE_ID)">{{selectedCover.COVERPAGE_TITLE}}</a>
		</span>		
		<label class="savedLabel col-md-4">Header: </label>
		<span class="col-md-7">
		<a *ngIf="selectedHeader?.HEADERFOOTER_ID" class="savedTitle"  href="javascript:void(0)" (click)="openHFPage(selectedHeader.HEADER_ID)">{{selectedHeader.HF_TITLE}}</a>
		</span>
		
		<label class="savedLabel col-md-4">Footer: </label>
		<span class="col-md-7">
		<a *ngIf="selectedFooter?.HEADERFOOTER_ID" class="savedTitle" href="javascript:void(0)" (click)="openHFPage(selectedFooter.FOOTER_ID)">{{selectedFooter.HF_TITLE}}</a>
		</span>
	</div>
	<input #file type="file" style="display: none;" (change)="uploadImage()"  accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG' />
	<input #file3 type="file" style="display: none;" (change)="uploadFile1()" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf">
	<input #file4 type="file" style="display: none;" (change)="uploadPdf()" accept='.pdf,.PDF'>
	<div class="row mt-0 mb-1 pl-2"  style="width:100%">
		<hr class="line1">
		<app-reportinfo [user]="tempInfo" (info)="onInfo($event)" (getLogo)="onSavedLogo($event)">
		</app-reportinfo>
	</div>
	</div>
	
	
    </div>
       
  </div>
	
</div>
</div>
</div>
 <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]" (didClosed)="showLogo = null">
    <ng-container name="body">
      <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo' (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
    </ng-container>
  </app-panel> 
</div>
	
	<div id="marginModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-sm modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Set Margin Size</h6>
		  <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<label class="col-md-7">Margin Top</label><input  min="0"   max="1000000000" class="col-md-4" type='number' [(ngModel)]="pageMargin.top"/>px<br>
			<label class="col-md-7">Margin Bottom</label><input min="0"   max="1000000000"  class="col-md-4" type='number' [(ngModel)]="pageMargin.bottom"/>px<br>	
			<label class="col-md-7">Margin Left</label><input  min="0"   max="1000000000" class="col-md-4" type='number' [(ngModel)]="pageMargin.left"/>px<br>
			<label class="col-md-7">Margin Right</label><input  min="0"   max="1000000000" class="col-md-4" type='number' [(ngModel)]="pageMargin.right"/>px<br>		
        </div>

	</div>
	</div>
	</div>
	<div id="uploadModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Choose upload type</h6>
		  <!--<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>-->
			<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<select [(ngModel)]="uploadType">
				<option value="photo">Photo</option>
				<option value="file">File ( PDF Only )</option>
			</select>
			<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-1 pb-1 ml-3" title="Add Image" (click)='upload()'><i class="fas fa-cloud-upload-alt"></i></a>
				<span id="spinner" class="fa fa-spinner fa-spin" style="font-size:24px; display:none"></span>
				<div name="form" *ngIf="uploadType=='photo'">
					<ng-container *ngFor="let photo of photos">
						<img class="bkImage" style="display:inline-block; width:100px; height:100px; margin:10px" [src]="photo.FILE_TN_URL">
					</ng-container>
					
				</div>	
				<!--<div *ngIf="uploadType=='file'">
					<ng-container *ngFor="let pdf of projectFiles">
						<a [href]="pdf.FILE_URL" target=_blank>{{pdf.FILE_NAME}}</a><br>
					</ng-container>
				</div>-->						
				
		
        </div>

	</div>
	</div>
	</div>
<div id="costLibModal" #costLibModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:40%">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">PCA Cost Library</h6>
		 	<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>        
        <!-- Modal body -->
        <div class="modal-body">				
			<div class="row p-1">
			<div style="height:400px; overflow:auto;width:55%; padding-left:10px">
			<p-table #dt5 [value]="pcaLibraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','IDENTIFIERS', 'UNIT', 'EUL', 'COST']">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th style="padding:2px">
							<p-dropdown [options]="pcaIdentifiers"  [(ngModel)]="filterText" placeholder="Identifier" [style]="{'width':'40%','minWidth':'30px', 'margin-left':'0','font-size':'11px'}"  [panelStyle]="{'font-size':'10px'}" (onChange)="dt5.filterGlobal($event.value,'contains')"  [showClear]="true"></p-dropdown>
							<span *ngIf="pcaLibraries.length==0" class="fa fa-spinner fa-spin" style="font-size:20px;"></span>
							<input type="text" pInputText size="12" [(ngModel)]="filterText" placeholder="Filter" (input)="dt5.filterGlobal($event.target.value, 'contains')" style="width:auto; margin-left:4px">
							
							<!--<button pButton label="Clear Filters"  class="p-button-outlined" icon="pi pi-filter-slash" (click)="dt5.reset()"></button>-->
						</th>
				
					</tr>		
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr>
						<td>
							<div class="card"  [ngClass]="{'active':curCostId.indexOf(rowData.COST_LIBRARY_ID)>-1}" (click)="selCost(rowData)"> 						
								<div class="row"><p style="width:75%; margin-left:16px; color:#C2D63F">{{rowData.ITEM_TITLE}}</p>
									<a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op4.toggle($event);"><i class="pi pi-eye"></i></a>					
								</div>
								<span>Cost: {{rowData.COST}}</span>
								<p-overlayPanel #op4 [appendTo]="costLibModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '340px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
											<h6>{{rowData.ITEM_TITLE}}</h6>
											<ng-container *ngFor="let label of rowData.IDENTIFIERS.split(';'); trackBy:trackByFuntion">
												<label class="tag">{{label}}</label>
											</ng-container>
											<div>
												<strong>Cost: </strong> <span style="color:white">{{rowData.COST}}</span><br>
												<strong>EUL: </strong> <span style="color:white">{{rowData.EUL}}</span><br>
												<strong>Unit: </strong> <span style="color:white">{{rowData.UNIT}}</span><br>
											</div>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>	
		</div>
		<div class="d-flex flex-column justify-content-center" style="width:9%">
					<button type="button" class="btn btn-outline-light btn-sm m-2" title="Add Cost Library" (click)="addSelCost()">></button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm m-2" title="Remove Cost Library" (click)="rmvAddedCost()"><</button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm m-2 p-1" title="Remove All Cost Libraries" (click)="clearAddedCost()"><<</button>
					<div style="height:30px"></div>
					<!--<button type="button" class="btn btn-outline-light btn-sm" title="Clear and Exit" (click)='cancleLib()'><i class="fas fa-sign-out-alt"></i></button>
					<div style="height:30px"></div>-->
					<button type="button" class="btn btn-outline-success btn-sm m-2" title="Add Cost Library to Recommendation" (click)='addLibToCost();filterText=""'><i class="far fa-save"></i></button>
					<div style="height:30px"></div>
					<span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>
				
				</div>
		<div class="rounded" style="height:400px; overflow:auto;width:35%; border:solid 1px rgb(195,212,47)">
			<ng-container *ngFor="let lib of addedCost; trackBy:trackByFuntion">
				<div class="card row m-1" style="width:94%" [ngClass]="{'active':curCostId.indexOf(lib.COST_LIBRARY_ID)>-1}" (click)="selCost(lib)"> 						
								Title : {{lib.ITEM_TITLE}}<br>
								<div class="row">
									<ng-container *ngFor="let label of lib.IDENTIFIERS.split(';'); trackBy:trackByFuntion">
										<label class="tag">{{label}}</label>
									</ng-container>
								</div>
								<p style="word-break: break-all">{{lib.COST}}</p>
				</div>
			</ng-container>
		</div>
		</div>

	</div>
	</div>
	</div>	
</div>	
